'use strict';

var ModulePath = require('../../constants/modulePath');
var moduleCodes = require('../../constants/moduleCodes');
var raPath = ModulePath[moduleCodes.MODULE_RA];

var RoutePath = require('../../constants/routePath');

exports.getRaModuleUrl = () => `/${raPath}`;
exports.getHomeUrl = () => `/${raPath}/${RoutePath.ROUTE_RA_HOME}`;
exports.getLatestAssessmentsUrl = () => `/${raPath}/${RoutePath.ROUTE_RA_LATEST_ASSESSMENTS}`;
exports.getLearnersPortfoliosUrl = () => `/${raPath}/${RoutePath.ROUTE_RA_LEARNERS_PORTFOLIOS}`;
exports.getLearnersPortfolioUrl = (id) => `/${raPath}/learners-portfolios/${id}`;
exports.getReportsUrl = () => `/${raPath}/${RoutePath.ROUTE_RA_REPORTS}`;
exports.getProfileUrl = () => `/${raPath}/${RoutePath.ROUTE_MY_PROFILE}`;
